// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default-layout[data-v-04cf86d8]{position:relative;display:flex;flex-direction:column;background-color:#edeef0;min-width:-webkit-min-content;min-width:-moz-min-content;min-width:min-content}.main[data-v-04cf86d8]{display:flex;min-height:calc(100vh - 90px)}", ""]);
// Exports
module.exports = exports;
